import { IProductNavigation } from '@adaptiva/core/app-shell';
import { Licensing } from '@adaptiva/core/licensing'; 

const _vmwareRoute: string = Licensing.PRODUCT_ROUTES.get(Licensing.Products.OneSite.VMWARE);

export const ONESITE_VMWARE_PRODUCT_NAVIGATION: IProductNavigation = {
	productName: Licensing.Products.OneSite.VMWARE,
	route: _vmwareRoute,
	sidenav: {
		productName: Licensing.Products.OneSite.VMWARE,
		sections: [{
			items: [
				{
					display: 'All Content Downloads',
					route: _vmwareRoute + '/dashboards/all-download-details',
					icon: 'faBoxesAltOutline',
				},
				{
					display: 'Content Download Details',
					route: _vmwareRoute + '/dashboards/content-download-details',
					icon: 'faBoxOpenOutline',
				},
				{
					display: 'Content for Device',
					route: _vmwareRoute + '/dashboards/content-for-device',
					icon: 'faBoxOutline',
				},
				{
					display: 'Device Download Details',
					route: _vmwareRoute + '/dashboards/device-download-details',
					icon: 'faDownloadOutline',
				},
				{
					display: 'Devices for Content',
					route: _vmwareRoute + '/dashboards/devices-for-content',
					icon: 'faDesktop',
				},
				{
					display: 'Live WAN Downloads',
					route: '/live-wan-downloads/download-status',
					icon: 'faChartNetworkOutline',
					linkedRoutes: [
						'/live-wan-downloads/download-status',
						'/live-wan-downloads/paused-downloads',
						'/live-wan-downloads/priority-overrides',
						'/live-wan-downloads/transport-overrides'
					],
				},
			]
		}]
	}
};
